import { combineReducers } from 'redux';
import googlePhotos from './googlePhotos';
import modalLayer from './modalLayer';
import plugins from '@/plugins';

const reducers = {
  googlePhotos,
  modalLayer,
};

// 'plugins' 하위에 등록된 플러그인에서 reducer 정보를 가져와서 'combine' 의 재료로 추가.
for (const pluginName in plugins) {
  if (
    plugins.hasOwnProperty(pluginName) &&
    plugins[pluginName].hasOwnProperty('reducer')
  ) {
    reducers[pluginName] = plugins[pluginName].reducer;
  }
}

export default combineReducers(reducers);
